import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { BUSINESS } from "../../config/business";

export const LOGO_HORIZONTAL = "https://www.jc3wealthlegacy.com/jc3-logo-horizontal-on-dark.svg";

const TopBar = ({ menuOpen, onToggleMenu }) => {
  const { user, logout } = useAuth();
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000 * 60);
    return () => clearInterval(id);
  }, []);

  const date = now.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });

  return (
    <header
      data-testid="top-nav-bar"
      className="h-16 w-full bg-[#0E1C15] border-b border-[rgba(200,164,106,.45)] flex items-center justify-between gap-4 px-4 sm:px-6 sticky top-0 z-40"
    >
      <div className="flex items-center gap-4 min-w-0">
        <button
          data-testid="mobile-menu-button"
          onClick={onToggleMenu}
          aria-expanded={menuOpen}
          className="min-[960px]:hidden h-9 px-3 border border-[rgba(200,164,106,.45)] text-[#F2EBDD] text-[13px] uppercase tracking-[.14em] hover:bg-[#14281E] transition-colors"
        >
          {menuOpen ? "Close" : "Menu"}
        </button>
        <img
          data-testid="brand-crest-mobile"
          src="https://www.jc3wealthlegacy.com/jc3-crest-on-dark.svg"
          alt={BUSINESS.shortName}
          className="h-8 w-auto shrink-0 sm:hidden"
        />
        <img
          data-testid="brand-wordmark"
          src={LOGO_HORIZONTAL}
          alt={BUSINESS.shortName}
          className="h-8 w-auto shrink-0 hidden sm:block"
        />
        <span className="hidden md:inline text-[#BDB6A6] text-sm whitespace-nowrap">Executive command center</span>
      </div>

      <div className="flex items-center gap-5 sm:gap-7 text-sm">
        <div className="hidden lg:flex items-center gap-2" data-testid="live-indicator">
          <span className="w-1.5 h-1.5 bg-[#C8A46A] bj-live" style={{ borderRadius: "50%" }} />
          <span className="text-[#BDB6A6]">Live</span>
        </div>
        <span data-testid="datetime-display" className="hidden sm:inline bj-tnum text-[#F2EBDD]">{date}</span>
        <div className="hidden sm:flex flex-col items-end leading-tight">
          <span data-testid="admin-name" className="text-[#F2EBDD]">{user?.name || "CEO Jace"}</span>
          <span className="text-[#BDB6A6] text-xs">Administrator</span>
        </div>
        <button
          data-testid="logout-button"
          onClick={logout}
          className="text-[#F2EBDD] underline decoration-[#C8A46A] underline-offset-4 hover:text-[#BDB6A6] transition-colors whitespace-nowrap"
        >
          Log out
        </button>
      </div>
    </header>
  );
};

export default TopBar;
